/* eslint-disable max-len */
import React from 'react';

export const LayoutGridIconNew = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 11H9.5C10.3 11 11 10.3 11 9.5V6.5C11 5.7 10.3 5 9.5 5H6.5C5.7 5 5 5.7 5 6.5V9.5C5 10.3 5.7 11 6.5 11ZM6 6.5C6 6.2 6.2 6 6.5 6H9.5C9.8 6 10 6.2 10 6.5V9.5C10 9.8 9.8 10 9.5 10H6.5C6.2 10 6 9.8 6 9.5V6.5ZM14.5 11H17.5C18.3 11 19 10.3 19 9.5V6.5C19 5.7 18.3 5 17.5 5H14.5C13.7 5 13 5.7 13 6.5V9.5C13 10.3 13.7 11 14.5 11ZM14 6.5C14 6.2 14.2 6 14.5 6H17.5C17.8 6 18 6.2 18 6.5V9.5C18 9.8 17.8 10 17.5 10H14.5C14.2 10 14 9.8 14 9.5V6.5ZM9.5 19H6.5C5.7 19 5 18.3 5 17.5V14.5C5 13.7 5.7 13 6.5 13H9.5C10.3 13 11 13.7 11 14.5V17.5C11 18.3 10.3 19 9.5 19ZM6.5 14C6.2 14 6 14.2 6 14.5V17.5C6 17.8 6.2 18 6.5 18H9.5C9.8 18 10 17.8 10 17.5V14.5C10 14.2 9.8 14 9.5 14H6.5ZM14.5 19H17.5C18.3 19 19 18.3 19 17.5V14.5C19 13.7 18.3 13 17.5 13H14.5C13.7 13 13 13.7 13 14.5V17.5C13 18.3 13.7 19 14.5 19ZM14 14.5C14 14.2 14.2 14 14.5 14H17.5C17.8 14 18 14.2 18 14.5V17.5C18 17.8 17.8 18 17.5 18H14.5C14.2 18 14 17.8 14 17.5V14.5Z"
      fill="currentColor"
    />
  </svg>
);
